export const APPOINTMENT_QUOTA = 20
export const APPOINTMENT_TIME_PERIODS = [
  '08:30-09:30', '09:30-10:30', '10:30-11:30', '11:30-12:00',
  '13:30-14:30', '14:30-15:30', '15:30-16:30', '16:30-17:30'
]

export function earliestAppointmentDate () {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(new Date())
  const value = type => Number(parts.find(part => part.type === type).value)
  const year = value('year'); const month = value('month'); const day = value('day')
  const tomorrow = new Date(Date.UTC(year, month - 1, day + 1))
  return tomorrow.toISOString().slice(0, 10)
}
